import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/commonColor.css";
import "./assets/css/commonButton.css";
import "./assets/css/commonSearch.css";
import "./assets/css/commonBlur.css";
import "./assets/css/commonText.css";
import "./assets/css/commonRecipe.css";
import "./assets/css/commonPantry.css";
import "./assets/css/commonCard.css"

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

createApp(App)
  .use(store)
  .use(router)
  .mount("#app");
